import script from "./RoleTag.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleTag.vue?vue&type=script&setup=true&lang=js"

import "./RoleTag.vue?vue&type=style&index=0&id=6d0311ff&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d0311ff"]])

export default __exports__